
<div class="sales-history-view">
  <ftu-block
    dismiss-key="shop"
    icon="search"
    title="Sales History"
    description="Our database contains 100M+ sales across millions of cards. Start searching and find out today's Card Ladder value for any card. The sales you see with green check marks were vetted by our experienced Research Team."
  />

  <align small-gap flex class="header">
    <align small-gap>
      <h1 class="secondary-font">
        Sales
      </h1>
      <external-link href="https://cardladder.zendesk.com/hc/en-us/articles/23672925718935-How-to-Search-Sales-History" />
    </align>

    <align v-show="!image" small-gap>
      <saved-filters
        type="sales"
        :query="q"
        :filters="filters"
        :is-filtering="isFiltering"
        @select="applySavedFilter"
      />

      <icon-button
        v-show="hasActiveProfileFiltering"
        icon="menu_book"
        class="pop-data-button"
        tooltip="View full pricing breakdown by grade"
        @click="showPopData"
      />
    </align>
  </align>

  <align flex collapse-end direction="flex-start">
    <shared-filters
      show-recent-searches
      placeholder="Search listing titles"
      search-icon="tag"
      :sales-platforms="platformOptions"
      :filters.sync="filters"
      :query.sync="q"
      :properties="defaultFilters"
      :hide-filters="Boolean(image)"
      @clear="clearFilters"
      @searchIconClick="certSearchOpen = true"
    />

    <align>
      <align small-gap>
        <icon-button
          icon="list"
          :class="{ success: salesHistoryViewType === 'list' }"
          @click="salesHistoryViewType = 'list'"
        />

        <icon-button
          icon="view_module"
          :class="{ success: salesHistoryViewType === 'grid' }"
          @click="salesHistoryViewType = 'grid'"
        />
      </align>

      <direction-sort-options
        :sort.sync="sort"
        :direction.sync="direction"
        :options="sortOptions"
      />
    </align>
  </align>

  <filter-results
    :is-filtering="isFiltering"
    :filters="filters"
    :results="numResults && numResults < 10000 ? numResults : null"
    :translation-map="filterResultsTranslationMap"
    :population="population"
    @clear="clearFilters"
  />

  <div v-if="showEstimateSlot" class="estimate">
    <align small-gap>
      <value-logo />

      <div v-if="showEstimate" class="value">
        {{ $filters.currency(estimateData.estimatedValue) }}
      </div>

      <div v-else class="value value-placeholder" />

      <icon
        v-if="showEstimate"
        v-tooltip="{ content: estimateDescription, delay: 100, placement: 'bottom' }"
        name="help_outline"
      />
    </align>
  </div>

  <div class="results">
    <empty-state
      v-if="showEmptyState"
      icon="search_off"
      title="There are no results for your query"
      description="Try searching for something else"
    />

    <template v-else>
      <div v-if="salesHistoryViewType === 'list'" class="list">
        <sales-list-item
          v-for="(item, i) in sales"
          :key="i"
          :item="item"
          as="router-link"
          :to="{ query: { ...$route.query, saleId: item.id } }"
          :href="item.url"
        >
          <align small-gap>
            <verified-icon v-if="item.cardId || item.memberVerified" />

            <icon-button
              v-if="isStaff"
              tooltip="Delete sale"
              icon="delete_outline"
              @click.stop.prevent="deleteSale(item)"
            />
          </align>
        </sales-list-item>
      </div>

      <div v-else class="grid">
        <sales-list-card
          v-for="(item, i) in sales"
          :key="i"
          :item="item"
          as="router-link"
          :to="{ query: { ...$route.query, saleId: item.id } }"
          :href="item.url"
          :verified="Boolean(item.cardId || item.memberVerified)"
        />
      </div>

      <infinite-scroll
        :loading="loading"
        :has-more-data="hasMoreData"
        @load="loadMore"
      />
    </template>
  </div>

  <modal
    title="Search Sales by Cert #"
    :open="certSearchOpen"
    @close="certSearchOpen = false"
  >
    <form @submit.prevent="searchCert">
      <text-input
        v-model="certInput"
        label="Cert #"
        placeholder="63444200"
      />

      <select-input
        v-model="graderInput"
        label="Grader"
        :options="graderOptions"
      />

      <div>
        <checkbox
          v-model="certShowGradeOnly"
          label="Show sales from this grade only"
        />
      </div>

      <btn type="submit" :disabled="!canSubmitCertSearch">
        Submit
      </btn>
    </form>
  </modal>

  <scroll-top />
</div>
